import { render } from "./BomValidationVersionToggleIncompleteTab.vue?vue&type=template&id=2c74097f&scoped=true"
import script from "./BomValidationVersionToggleIncompleteTab.vue?vue&type=script&lang=js"
export * from "./BomValidationVersionToggleIncompleteTab.vue?vue&type=script&lang=js"

import "./BomValidationVersionToggleIncompleteTab.vue?vue&type=style&index=0&id=2c74097f&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c74097f"]])

export default __exports__